import { IColorConvertModule } from '@leafer-ui/interface'

import { string } from './color'


export const ColorConvertModule = {
    string
} as IColorConvertModule